import { Button } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useState } from 'react'

interface CopyButtonProps {
  code: string
}

function CopyButton({ code }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)
  function copyToClipboard() {
    navigator.clipboard.writeText(code.trim())
    setCopied(true)
  }

  const textColor = copied ? 'common.white' : 'inherit'
  const bgColor = copied ? 'success.light' : 'background.default'

  return (
    <Button
      size='small'
      variant='contained'
      onClick={copyToClipboard}
      sx={{
        fontSize: '12px',
        color: textColor,
        backgroundColor: bgColor,
        boxShadow: 'none',
        padding: '4px 6px',
        borderRadius: '4px',
        position: 'absolute',
        top: '4px',
        right: '4px',
        ' &:hover': {
          color: textColor,
          backgroundColor: bgColor,
          boxShadow: 'none',
        },
      }}
    >
      {copied ? (
        <CheckIcon sx={{ fontSize: '14px', marginRight: '4px' }} />
      ) : (
        <ContentCopyIcon sx={{ fontSize: '14px', marginRight: '4px' }} />
      )}
      Copy Code
    </Button>
  )
}

export default CopyButton
